export enum EAirBookingPermissions {
    SHARED_AIR_BOOKING_ANCILLARY_SERVICES_USE = "shared.air.booking.ancillaryServices.use",
    SHARED_AIR_BOOKING_ANCILLARY_SERVICES_VIEW = "shared.air.booking.ancillaryServices.view",
    SHARED_AIR_BOOKING_CANCEL = 'shared.air.booking.cancel',
    SHARED_AIR_BOOKING_DETAIL_FARE_RULES_SEARCH = 'sasha.booking.detail.air.fareRules.search',
    SHARED_AIR_BOOKING_EXPORT_TEXT = 'shared.air.booking.exportText',
    SHARED_AIR_BOOKING_FARE_OPT_HISTORY_SHOW = "shared.air.booking.fareOptHistory.show",
    SHARED_AIR_BOOKING_ISSUE = 'shared.air.booking.issue',
    SHARED_AIR_BOOKING_OPERATIONS_SHOW = "shared.air.booking.operations.show",
    SHARED_AIR_BOOKING_PRICE_HISTORY_SHOW = "shared.air.booking.price.history.show",
    SHARED_AIR_BOOKING_PRICE_SHOW = "shared.air.booking.price.show",
    SHARED_AIR_BOOKING_QUALITY_CHECK = 'shared.air.booking.qualityCheck',
    SHARED_AIR_BOOKING_REMARKS_SHOW = "shared.air.booking.remarks.show",
    SHARED_AIR_BOOKING_SEGMENT_MODIFY = 'shared.air.booking.segment.modify',
    SHARED_AIR_BOOKING_SERVICES_ADD = 'shared.air.booking.services.add',
    SHARED_AIR_BOOKING_SERVICES_SHOW = "shared.air.booking.services.show",
    SHARED_AIR_BOOKING_SHOW = "shared.air.booking.show",
    SHARED_AIR_BOOKING_VOID = 'shared.air.booking.void',
    SHARED_BOOKING_SYNCHRONIZE = 'shared.booking.synchronize',
    SHARED_STAY_VOUCHER = 'shared.stay.booking.voucher',
    SHARED_VEHICLERENTAL_VOUCHER = 'shared.vehicleRental.booking.voucher',
}

export enum EBookingPermissions {
    SHARED_BOOKING_SAPEIG_BALANCE_VIEW = "shared.booking.sapeig.balance.view",
}

